import { ReferenceArea } from 'recharts'

import styles from './RestrictedDatesForCharts.module.scss'

export const renderReferenceArea = restrictedDates => {
  let isHovering = false

  return restrictedDates
    ?.filter((value, index, self) => {
      return self.findIndex(v => v.startDate === value.startDate) === index
    })
    ?.map(d => (
      <ReferenceArea
        x1={d.startDate}
        x2={d.endDate}
        onMouseEnter={() => (isHovering = true)}
        onMouseLeave={() => (isHovering = false)}
        fill="#FFF2F2"
        fillOpacity={1}
        opacity={100}
        className={styles.customizedReferenceArea}
        yAxisId="left"
        label={({ viewBox }) => (
          <g>
            {!isHovering && (
              <text
                x={viewBox.x + viewBox.width / 2}
                y={viewBox.y - 15}
                dominant-baseline="middle"
                text-anchor="middle"
                fill="#F87171"
                dy={0}
                dx={0}
                fontSize={4}
                className={styles.customizedReferenceAreaBullet}
              >
                {'\u2B24'}
              </text>
            )}
            <text
              x={viewBox.x + viewBox.width / 2}
              y={viewBox.y - 18}
              dominant-baseline="middle"
              text-anchor="middle"
              fill="#F87171"
              dy={0}
              dx={0}
              fontSize={10}
              className={styles.customizedReferenceAreaLabel}
            >
              {d.name}
            </text>
          </g>
        )}
      />
    ))
}
